import { useEffect, useState } from "react";
import api from "@/lib/api";
import { eur, fmtDate } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { Loader2, Gift, Package, Wallet } from "lucide-react";

export default function PortalWallet() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/portal/wallet").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="h-64 flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-[hsl(var(--hi-gold))]" /></div>;
  return (
    <div className="space-y-5">
      <h1 className="font-heading text-2xl font-semibold">Wallet</h1>
      <Card className="p-4 flex items-center gap-3"><Wallet className="h-7 w-7 text-[hsl(var(--hi-status-info))]" /><div><div className="text-xs text-muted-foreground">Credito disponibile</div><div className="font-heading text-2xl font-semibold">{eur(d.credit)}</div></div></Card>

      <div>
        <h3 className="font-heading text-lg font-semibold mb-2 flex items-center gap-2"><Gift className="h-5 w-5 text-[hsl(var(--hi-gold))]" /> Gift Card</h3>
        <div className="space-y-3">
          {d.giftcards.length === 0 && <Card className="p-4 text-sm text-muted-foreground text-center">Nessuna Gift Card.</Card>}
          {d.giftcards.map((g) => (
            <Card key={g.id} className="p-4 hi-plaque text-[hsl(36_44%_96%)]">
              <div className="flex justify-between"><Badge className="bg-[hsl(42_60%_52%)] text-black">{g.code}</Badge><span className="text-xs opacity-70">Scad. {fmtDate(g.expiry)}</span></div>
              <div className="mt-3"><div className="text-xs opacity-70">Saldo</div><div className="font-heading text-3xl font-semibold">{eur(g.balance)}</div></div>
            </Card>
          ))}
        </div>
      </div>

      <div>
        <h3 className="font-heading text-lg font-semibold mb-2 flex items-center gap-2"><Package className="h-5 w-5 text-[hsl(var(--hi-gold))]" /> Pacchetti & Abbonamenti</h3>
        <div className="space-y-3">
          {d.packages.length === 0 && <Card className="p-4 text-sm text-muted-foreground text-center">Nessun pacchetto attivo.</Card>}
          {d.packages.map((p) => (
            <Card key={p.id} className="p-4">
              <div className="flex justify-between"><span className="font-medium">{p.name}</span><span className="text-sm text-muted-foreground">Scad. {fmtDate(p.expiry)}</span></div>
              <div className="flex justify-between text-sm mt-2 mb-1"><span className="text-muted-foreground">Utilizzi residui</span><span className="font-medium">{p.remaining} / {p.total}</span></div>
              <Progress value={(p.remaining / p.total) * 100} className="h-2" />
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
